module.exports = __webpack_public_path__ + "static/img/index_bg.218c6bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/index_bg.jpg
// module id = VsGI
// module chunks = 0